import { render, staticRenderFns } from "./BookingItemLoader.vue?vue&type=template&id=20cdd21c"
import script from "./BookingItemLoader.vue?vue&type=script&lang=js"
export * from "./BookingItemLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports